<template>
  <div class="goods_add">

      <el-card>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="快递名称" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>



      <div class="mt-20"></div>

      <el-form-item class="quill-editor-top">
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"

          >添加</el-button
        >


        <el-button @click="resetForm('ruleForm')" ref="ruleForm">重置</el-button>
      </el-form-item>
    </el-form>
      </el-card>
    <el-card class="mt-20">



        <el-table
                :data="logistics_data"
                style="width: 100%">
            <el-table-column
                    label="名称"
                    width="180">
                <template slot-scope="scope">

                    <span style="margin-left: 10px">{{ scope.row.name }}</span>
                </template>
            </el-table-column>


            <el-table-column label="操作">
                <template slot-scope="scope">





                    <el-button

                            size="mini"
                            type="primary"
                            @click="configuration(scope.$index, scope.row)"


                    >配置</el-button>

                    <el-button
                            size="mini"
                            @click="edit(scope.$index, scope.row)">编辑</el-button>
                    <el-button
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>


    </el-card>
      <el-dialog title="编辑" :visible.sync="dialogFormVisible">
          <el-form :model="ruleForm">
              <el-form-item label="名称" :label-width="formLabelWidth">
                  <el-input v-model="ruleForm.name" autocomplete="off"></el-input>
              </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="save">确 定</el-button>
          </div>
      </el-dialog>
      <el-dialog :title="express_name" :visible.sync="dialogFormVisible1">

          <el-table :data="area_data">
              <el-table-column property="name" label="名称" width="150"></el-table-column>
              <el-table-column property="name" label="首重价格" width="200">

                  <template  slot-scope="scope" >

                      <el-input
                              placeholder="请输入内容"
                              v-model="first_weight[scope.row.name]"

                              clearable>
                      </el-input>
                  </template>
              </el-table-column>
              <el-table-column property="name" label="续重价格" width="200">
                  <template  slot-scope="scope" >

                      <el-input
                              placeholder="请输入内容"
                              v-model="second_weight[scope.row.name]"
                              clearable>
                      </el-input>
                  </template>

              </el-table-column>
              <el-table-column property="name" label="单位/kg">
                  <template slot-scope="scope">

                    <div>

                        <el-input
                                placeholder="请输入数字"
                                v-model="unit[scope.row.name]"
                                clearable>
                        </el-input>

                    </div>


                  </template>
              </el-table-column>
          </el-table>
          <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible1 = false">取 消</el-button>
              <el-button type="primary" @click="saveExpressPrice">确 定</el-button>
          </div>
      </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
        unit:{},
        first_weight:{},
        second_weight:{},

        logistics_data:[],
        area_data:[],
        formLabelWidth: '120px',
      id: 0,
      express_name:"",

        ruleForm: {
        name: "",
      },
      dialogFormVisible: false,
        dialogFormVisible1: false,
      rules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],


      },
    };
  },
  computed: {
    ...mapState({
        logistics: (state) => state.logistics.result,
        area: (state) => state.area.result,
        express_price_data: (state) => state.express_price.result,

    }),
  },
  methods: {
    ...mapActions({
      getLogisticsIndexAction: "getLogisticsIndexAction",
      addLogisticsAction: "addLogisticsAction",
      deleteLogisticsAction:"deleteLogisticsAction",
      editLogisticsAction:"editLogisticsAction",
      getAreaListAction:"getAreaListAction",
      getExpressPriceIndexAction:"getExpressPriceIndexAction",
      editExpressPriceAction:"editExpressPriceAction"

    }),



      edit(index, row) {
          this.dialogFormVisible=true
          this.ruleForm.name=row.name
          this.id=row.id
          console.log(index, row);
      },
      save(){
         this.dialogFormVisible = false
         this.editLogisticsAction({name:this.ruleForm.name,id:this.id})
      },
      configuration(index,row){
          this.dialogFormVisible1=true
          this.express_name=row.name
          this.getExpressPriceIndexAction({name:this.express_name})
          console.log(index, row);
      },
      handleDelete(index, row) {
          console.log(index, row);

          this.deleteLogisticsAction({"id":row.id})
      },

    saveData() {

        this.addLogisticsAction({
            name: this.ruleForm.name,

        });

    },
      saveExpressPrice() {

          let data={
              express_name:this.express_name,
              unit:JSON.stringify(this.unit),
              first_weight:JSON.stringify(this.first_weight),
              second_weight:JSON.stringify(this.second_weight),
          }
          this.editExpressPriceAction(data);
          this.dialogFormVisible1=false

      },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          this.$message("请输入正确信息");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  created() {
    this.getLogisticsIndexAction({});
    this.getAreaListAction({})

  },
  watch: {
      area(newdata, olddata){
          console.log(newdata, olddata)
          this.area_data=newdata.data
          for(let i in this.area_data){

              this.$set(this.unit,this.area_data[i].name,1)
              this.$set(this.first_weight,this.area_data[i].name,0)
              this.$set(this.second_weight,this.area_data[i].name,0)

          }

      },
      express_price_data(newdata){
          if(newdata.code==301){
              this.$message({
                  message: '编辑成功',
                  type: 'success'
              });

          }
          if(newdata.code==200){

              let express_price=newdata.data

              if(express_price.length>0){

                  for(let i in express_price){

                      this.$set(this.first_weight,express_price[i].province,express_price[i].first_weight)
                      this.$set(this.second_weight,express_price[i].province,express_price[i].second_weight)
                      this.$set(this.unit,express_price[i].province ,express_price[i].unit)


                  }
              }else{

                  for(let i in this.area_data){

                      this.$set(this.unit,this.area_data[i].name,1)
                      this.$set(this.first_weight,this.area_data[i].name,0)
                      this.$set(this.second_weight,this.area_data[i].name,0)

                  }
              }
          }

      },
      logistics(newdata, olddata) {
      if(newdata.code==200){
          this.logistics_data=newdata.data


      }
          if(newdata.code==400){
              this.$message({
                  message: '快递已经存在',
                  type: 'error'
              });
          }
      if (newdata.code == 301) {

          this.$message({
              message: '添加成功',
              type: 'success'
          });
         this.getLogisticsIndexAction({});
      }
      if (newdata.code == 302) {

          this.$message({
              message: '更新成功',
              type: 'success'
          });
          this.ruleForm.name=''
          this.id=0
          this.getLogisticsIndexAction({});
      }
      if (newdata.code == 303) {

          this.$message({
              message: '删除成功',
              type: 'success'
          });


        this.getLogisticsIndexAction({});
      }


      console.log(newdata, olddata);
    },
  },
};
</script>



<style>


.avatar-uploader .el-upload {
  border: 1px dashed #260a0a;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.title_bg {
  background-color: #f5fffa;
  padding: 10px;
}

.el-form-item__content {
  margin-left: 30px;
}
</style>
